

function Footer() {
        return (
            <footer className="w-1/2 mx-auto h-8 transparent bg-gray-600 bottom-0 items-center inset-x-0">
                <div className="flex justify-center m-3 pt-1 w-100">
                   &copy; <a href="https://afrodemoz.tk/"> ADZ Community</a>
                </div>
            </footer>
        )
}

export default Footer;
